import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'simpleMemory',
  version: '1.0.0',
  properties: [
    // ==================================================================
    // SESSION CONFIGURATION
    // ==================================================================
    {
      key: 'sessionIdSource',
      label: 'Session ID',
      type: 'options',
      required: true,
      default: 'auto',
      options: [
        { value: 'auto', name: 'Connected Chat Trigger Node' },
        { value: 'custom', name: 'Custom Expression' },
      ],
      description: 'Where to get the session ID from',
    },
    {
      key: 'sessionIdExpression',
      label: 'Session Key From Previous Node',
      type: 'string',
      required: false,
      default: '{{ $json.sessionId }}',
      placeholder: 'e.g., {{ $json.sessionId }}',
      description: 'Expression to extract session ID from previous node output',
      displayOptions: {
        show: {
          sessionIdSource: ['custom'],
        },
      },
    },
    
    // ==================================================================
    // MEMORY CONFIGURATION
    // ==================================================================
    {
      key: 'memoryType',
      label: 'Memory Type',
      type: 'options',
      required: true,
      default: 'buffer',
      options: [
        { value: 'buffer', name: 'Buffer (Keep last N messages)' },
        { value: 'window', name: 'Window (Keep first + last N messages)' },
        { value: 'summary', name: 'Summary (Summarize old messages)' },
      ],
      description: 'How to store conversation history',
    },
    {
      key: 'contextWindowLength',
      label: 'Context Window Length',
      type: 'number',
      required: false,
      default: 30,
      typeOptions: {
        minValue: 1,
        maxValue: 100,
      },
      description: 'How many past interactions the model receives as context',
    },
    
    // ==================================================================
    // ADVANCED OPTIONS
    // ==================================================================
    {
      key: 'includeSystemMessages',
      label: 'Include System Messages',
      type: 'boolean',
      required: false,
      default: false,
      description: 'Include system messages in conversation history',
    },
    {
      key: 'contextWindow',
      label: 'Max Context Tokens',
      type: 'number',
      required: false,
      default: 4096,
      typeOptions: {
        minValue: 100,
        maxValue: 200000,
      },
      description: 'Maximum tokens for context (affects how much history is sent)',
    },
  ],
};

export default schema;
